(() => {
  const button = document.querySelector('[data-rednib-whatsapp]');
  if (!button) return;

  const visible = (element) => {
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0
      && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth
      && (!element.checkVisibility || element.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true }))
      && style.visibility !== 'hidden'
      && style.display !== 'none' && Number(style.opacity) !== 0;
  };
  const overlaps = (a, b) => a.left < b.right + 12 && a.right > b.left - 12
    && a.top < b.bottom + 12 && a.bottom > b.top - 12;

  function update() {
    const typing = matchMedia('(max-width: 767.98px)').matches
      && document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
    const blocking = [...document.querySelectorAll(
      'dialog[open], .drawer[open], [aria-modal="true"], #iubenda-cs-banner, .iubenda-cs-preferences-link + iframe'
    )].some(visible);
    if (typing || blocking) {
      button.hidden = true;
      return;
    }

    button.hidden = false;
    button.style.transform = '';
    const initial = button.getBoundingClientRect();
    // Avoid action buttons and fixed app controls. Large product/image links
    // in the normal page flow are content, not floating obstacles.
    const obstacles = [...document.querySelectorAll(
      'a, button, input, select, textarea, iframe, [role="button"], terms-agreement, .rednib-cart-summary, sticky-atc:not(.sticky-atc--out)'
    )].filter((element) => {
      if (button.contains(element) || element === button || !visible(element)) return false;
      if (element.tagName !== 'A' || element.matches('.btn, [role="button"]')) return true;
      for (let parent = element; parent && parent !== document.body; parent = parent.parentElement) {
        if (['fixed', 'sticky'].includes(getComputedStyle(parent).position)) return true;
      }
      return false;
    })
      .map((element) => element.getBoundingClientRect());
    let shift = 0;
    for (let pass = 0; pass < 8; pass += 1) {
      const rect = { left: initial.left, right: initial.right, top: initial.top - shift, bottom: initial.bottom - shift };
      const collisions = obstacles.filter((obstacle) => overlaps(rect, obstacle));
      if (!collisions.length) break;
      shift = Math.max(...collisions.map((obstacle) => initial.bottom - obstacle.top + 12), shift);
    }
    const moved = { left: initial.left, right: initial.right, top: initial.top - shift, bottom: initial.bottom - shift };
    if (shift > Math.min(innerHeight * 0.45, 320) || moved.top < 16
      || obstacles.some((obstacle) => overlaps(moved, obstacle))) {
      button.hidden = true;
      return;
    }
    button.style.transform = shift ? `translateY(-${shift}px)` : '';
  }

  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; update(); });
  }
  const observer = new MutationObserver((records) => {
    if (records.some((record) => record.target !== button)) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true,
    attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-hidden', 'aria-expanded'] });
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('focusin', schedule);
  addEventListener('focusout', schedule);
  document.addEventListener('load', schedule, true);
  document.addEventListener('transitionend', schedule);
  window.visualViewport?.addEventListener('resize', schedule);
  schedule();
})();
